import { render, staticRenderFns } from "./secAuth.vue?vue&type=template&id=2fc153d0&"
import script from "./secAuth.vue?vue&type=script&lang=js&"
export * from "./secAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports